import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import classNames from 'classnames/bind';
import { path } from 'ramda';
import axios from 'axios';

import {
  I18n,
  Icon,
  Preloader,
  Link,
} from 'components';

import { modifyArray } from 'utils/mergeDuplicates';
import Service from '../../components/Service';
import { fetchData, refetchData, disconnectService } from '../../actions';
import styles from '../../styles.pcss';

const cx = classNames.bind(styles);

const TARIFF_TYPE = 'YandexTariffSubscription';

class ConnectedServices extends Component {
  static buildServiceConfig(actions, service) {
    return ({
      actions,
      key: service.url,
      ...service,
      rate: service.rcRate,
      ratePeriod: service.rcRatePeriodText,
      rateDate: service.rcRateDate,
      rateAfterChange: service.rcRateAfterChange,
      changRateDate: service.changRateDate,
      currency: service.currencyText,
      dateConnect: new Date(service.dateConnect),
      dateDisconnect: new Date(service.dateDisconnect),
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      partnershipTariffInfo: {},
    };
  }

  componentDidMount() {
    this.props.actions.fetchData(['ConnectedServices', 'Services', 'Status']);
  }

  componentDidUpdate(prevProps) {
    if (prevProps.services !== this.props.services) {
      const isPartnershipTariff = this.props.services.find((service) => service.type === TARIFF_TYPE);
      if (isPartnershipTariff) {
        const getSubscriptionInfo = async () => {
          try {
            const res = await axios
              .get('/api/yandex-tariff-subscription/', {
                params: {
                  redirectUrl: `${window.location.pathname}${window.location.hash}`,
                },
              });
            if (res?.data?.status) {
              this.setState({ partnershipTariffInfo: {
                account: res.data?.account,
                bonus: res.data?.bonus,
                soc: isPartnershipTariff.soc[0],
              } });
            }
          } catch (e) {
            console.error(e);
          }
        };
        getSubscriptionInfo();
      }
    }
  }

  render() {
    const {
      actions,
      services,
      catalogLink,
      isLoading,
      isError,
      isRestrictedAccess,
    } = this.props;

    if (isLoading) {
      return (
        <div className={cx('preloaderWrapper')}>
          <Preloader className={cx('preloader')} size="80" />
        </div>
      );
    }

    if (isError) {
      return (
        <div className={cx('container', 'message')}>
          <Icon className={cx('icon')} name="smile-dead" />
          <div>
            <I18n path="services.servicesLoadingError" />
            <br />
            <I18n path="services.try" />
&nbsp;
            <Link onClick={() => actions.refetchData('ConnectedServices')}>
              <I18n path="services.refresh" />
            </Link>
&nbsp;
            <I18n path="services.inAMinute" />
          </div>
        </div>
      );
    }

    return (
      <div className={cx('container')}>
        {services && services.map((service) => (
          <Service
            isRestrictedAccess={isRestrictedAccess}
            {...ConnectedServices.buildServiceConfig(actions, service)}
            partnershipTariffInfo={this.state.partnershipTariffInfo}
          />
        ))}

        <div className={cx('catalogLink')}>
          <I18n path="services.goTo" />
          {' '}
          <Link href={catalogLink}>
            <I18n path="services.servicesCatalog" />
          </Link>
        </div>
      </div>
    );
  }
}

ConnectedServices.defaultProps = {
  isError: false,
  isLoading: false,
};

ConnectedServices.propTypes = {
  actions: PropTypes.object,
  services: PropTypes.array,
  catalogLink: PropTypes.string,
  isError: PropTypes.bool,
  isLoading: PropTypes.bool,
  isPreloader: PropTypes.bool,
  isRestrictedAccess: PropTypes.bool,
};

const mapStateToProps = ({ services, application }) => {
  const { error, isPreloader, connectedServices } = services;
  const { data } = connectedServices;

  return {
    services: data instanceof Array ? modifyArray(data, 'soc') : data,
    catalogLink: path(['services', 'data', 'servicesCatalogLink'], services),
    isError: Boolean(error),
    isLoading: isPreloader && services.loadingBlocks.some((i) => i === 'ConnectedServices'),
    isRestrictedAccess:
      application.settings.isRestrictedAccess
      || path(['status', 'data', 'status'], services) === 'Blocked',
  };
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({
      fetchData,
      refetchData,
      disconnectService,
    }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ConnectedServices);
